/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useArticles } from "../../store/useArticles";
import { useEffect } from "react";
import { ArticleCategoriesTable } from "./ArticleCategoriesTable";

function ArticleCategoriesScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const { getCategories, categories } = useArticles();

  const addArticleCategory = () => navigate("/add-article-category");

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Article Categories
        </h1>
        <PrimaryButton
          onClick={addArticleCategory}
          label="Add new category"
          className="h-10"
        />
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!categories?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no article category created yet.
          </p>
        ) : (
          <ArticleCategoriesTable />
        )}
      </div>
    </div>
  );
}

export default withProtectedRoute(ArticleCategoriesScreen);
